<template>
    <div class="container-policies">
        <menu>
            <router-link :class="{active: path == '/terms-of-services' }" to="/terms-of-services">Terms of Service</router-link>
            <router-link :class="{active: path == '/privacy-notice' }" to="/privacy-notice">Privacy Notice</router-link>
            <router-link :class="{active: path == '/warranty' }" to="/warranty">Warranty</router-link>
            <router-link :class="{active: path == '/open-source-agreement' }" to="/open-source-agreement">Open Source Agreement</router-link>
            <router-link :class="{active: path == '/software-end-user-license-agreement' }" to="/software-end-user-license-agreement">Software End User License Agreement</router-link>
            <router-link :class="{active: path == '/return-policy' }" to="/return-policy">Return Policy</router-link>
            <router-link :class="{active: path == '/sales-terms' }" to="/sales-terms">Sales Terms</router-link>
        </menu>
        <span class="tglic"></span>
    </div>
</template>
<script>
export default {
    name: 'ContentItem',
    props:{
        itemData:{}
    },
    data(){
        return {
            path: ''
        }
    },
    mounted() {
        let url = location.pathname;
        this.path = url;

        jQuery('.pnbox .tglic').click(function(){
        if(jQuery(this).hasClass('close1')){
            jQuery('.pnbox .mlist').animate({"left":"-60%"}, 500);
            jQuery(this).removeClass('close1');
        }else{            
            jQuery('.pnbox .mlist').animate({"left":"00"}, 500);
            jQuery(this).addClass('close1');
        }
        })
        jQuery('body').on('touchstart', function(){
            if(jQuery('.pnbox .tglic').hasClass('close1')){
                jQuery('.pnbox .mlist').animate({"left":"-60%"}, 500);
                jQuery('.pnbox .tglic').removeClass('close1');
            }        
        })
    },
}
</script>
<style lang="scss" scope>
@import '@/assets/css/privacy-notice.scss';
.container-policies{
    menu{
        background: #ffffff;
        // .router-link-active{
        //     color: $clrba0c2f !important;            
        //     &::before{
        //         content: '';
        //         display: block;
        //         width: 3px;
        //         height: 100%;
        //         background: $clrba0c2f;
        //         position: absolute;
        //         left: 0;
        //         top: 0;
        //         @media screen and (max-width: 800px) {
        //             left: unset;
        //             right: 0;
        //         }
        //     }
        // }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/policies/modules/policies-nav.vue